import { render } from "./Kakutei.vue?vue&type=template&id=4033fa43&scoped=true"
import script from "./Kakutei.vue?vue&type=script&lang=js"
export * from "./Kakutei.vue?vue&type=script&lang=js"

import "./Kakutei.vue?vue&type=style&index=0&id=4033fa43&scoped=true&lang=css"
import "./Kakutei.vue?vue&type=style&index=1&id=4033fa43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4033fa43"

export default script